import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setSubChart, removeSubChart } from "../logic/chartSub"
import { SUB_CHART, TERM, PLOTTYPE } from "../logic/chartConfig"
import {
  changeSubChart,
  changeSubSelected,
  changeSubChartOptions,
  chartPropatyObj,
  pickTarget,
} from "redux/ducks/Chart"
import SubChartPropety from "./SubChartPropety"
import { Btn } from "components/atoms/btn"
import _ from "lodash"
import ClassNames from "classnames"
import { setToastData } from "redux/ducks/Toast"
import { useChartTechToolTip } from "components/atoms/chart/parts/ChartTechToolTip"

interface props {
  canvasId: string
}

interface subChartOptionsProps extends props {
  subChartId: number
  options: Array<chartPropatyObj>
}

const SubChart = React.memo((props: props) => {
  const { canvasId } = props
  const dispatch = useDispatch()
  const providerSelector = (state: any) => state.chart[canvasId].providers
  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const relativeChartFlagSelector = (state: any) =>
    state.chart[canvasId].relativeChartFlag
  const subSelectedSelector = (state: any) => state.chart[canvasId].subSelected
  const colorSettingSelector = (state: any) => state.chart.colorSetting
  const chartSettingSelector = (state: any) => state.chart.chartSetting
  const termSelector = (state: any) => state.chart[canvasId].term
  const providers = useSelector(providerSelector)
  const plotType = useSelector(plotTypeSelector)
  const symbolSelector = (state: any) => state.chart[canvasId].symbol
  const term = useSelector(termSelector)
  const symbol = useSelector(symbolSelector)
  const relativeChartFlag = useSelector(relativeChartFlagSelector)
  const colorSetting = useSelector(colorSettingSelector)
  const chartSetting = useSelector(chartSettingSelector)

  const subChartOptionsSelector = (state: any) =>
    state.chart[canvasId].subChartOptions[term.id]
  const spredSelector = (state: any) => state.chart[canvasId].spred
  const subChartOptions = useSelector(subChartOptionsSelector)
  const subSelected = useSelector(subSelectedSelector)
  const spred = useSelector(spredSelector)

  const [_provider, _controller, _procs] = providers
  const [selectedItems, setSelectedItems] = useState(subSelected)
  const [selectedSpred, setSeletedSpred] = useState(spred)
  const [prevSubSelected, setPrevSubSelected] = useState(subSelected)
  const [visibleList, setVisibleList] = useState([])
  const [prevColorSetting, setprevColorSetting] = useState(colorSetting)

  const [tooltipVisible, setTooltipVisible] = useState<number>(null)
  const { _setPosition, createToolTip } = useChartTechToolTip({ type: 1 })

  const setSelect = (id: number) => {
    if (_.isEmpty(symbol)) return
    let _selectedItems = _.clone(selectedItems)
    if (_.includes(_selectedItems, id)) {
      _.pull(_selectedItems, id)
    } else {
      if (selectedItems.length >= 3) return
      _selectedItems.push(id)
    }
    setSelectedItems(_selectedItems)
  }

  const _setVisibleList = (id: number) => {
    let _visibleList = _.clone(visibleList)
    if (_.includes(_visibleList, id)) {
      _.pull(_visibleList, id)
    } else {
      _visibleList.push(id)
    }
    setVisibleList(_visibleList)
  }

  useEffect(() => {
    const _selectedItems = _.clone(selectedItems)
    if (selectedSpred) _selectedItems.push(SUB_CHART[19].id)
    dispatch(changeSubSelected(canvasId, _selectedItems))
  }, [selectedItems, selectedSpred])

  // ColorSettingに変更があった場合作り直しが必要
  useEffect(() => {
    if (_.isEqual(colorSetting, prevColorSetting) || relativeChartFlag) return
    setprevColorSetting(colorSetting)
    _.forEach(selectedItems, index => {
      removeSubChart(SUB_CHART[index].key, _controller)
      const targetOptions = _.pick(subChartOptions, SUB_CHART[index].key)
      setSubChart(chartSetting, SUB_CHART[index].key, _controller)
      if (_.isEmpty(targetOptions)) return
      let keys: Array<string> = []
      _.forEach(targetOptions[SUB_CHART[index].key], options => {
        keys.push(options.key)
      })
      setSubChart(
        chartSetting,
        SUB_CHART[index].key,
        _controller,
        term.key,
        keys,
        true
      )
    })
  }, [colorSetting])

  useEffect(() => {
    if (_.isEqual(prevSubSelected, subSelected)) return
    setSelectedItems(subSelected)
    setPrevSubSelected(subSelected)
  }, [subSelected])

  useEffect(() => {
    setSeletedSpred(spred)
  }, [spred])

  return (
    <div className="chart-setting-category category-sub">
      {_.map(SUB_CHART, items => {
        return (
          <div key={items.id} className="chart-setting-item">
            <div
              className="chart-setting-header"
              onMouseOut={() => {
                if (!_.isNull(tooltipVisible)) setTooltipVisible(null)
              }}
            >
              {selectedItems.length >= 3 &&
                !_.includes(selectedItems, items.id) &&
                items.id !== SUB_CHART[19].id && (
                  <div
                    className="toast-trigger"
                    onClick={() => {
                      dispatch(
                        setToastData({
                          bodyMessage:
                            "＊同時に設定できる上限数に達しました。\nアドオンは5つ、サブチャートは３つまでが設定可能となっております。",
                        })
                      )
                    }}
                  />
                )}
              <label className="checkbox-control">
                <input
                  type="checkbox"
                  value={items.id}
                  disabled={
                    _.isEmpty(symbol) ||
                    (relativeChartFlag && items.id !== 19) ||
                    (selectedItems.length >= 3 &&
                      !_.includes(selectedItems, items.id) &&
                      items.id !== SUB_CHART[19].id) ||
                    (items.id === SUB_CHART[16].id && term.id !== TERM[9].id) ||
                    plotType.id === PLOTTYPE[3].id ||
                    (!relativeChartFlag && items.id === SUB_CHART[19].id)
                  }
                  checked={
                    items.id !== SUB_CHART[19].id
                      ? _.includes(selectedItems, items.id)
                      : selectedSpred
                  }
                  onChange={
                    items.id !== SUB_CHART[19].id
                      ? () => setSelect(items.id)
                      : () => setSeletedSpred(!selectedSpred)
                  }
                />
                <span />
              </label>
              <Btn
                onClick={
                  items.id !== SUB_CHART[19].id
                    ? () => setSelect(items.id)
                    : () => setSeletedSpred(!selectedSpred)
                }
                name={items.displayTitle}
                className={ClassNames({
                  disabled:
                    _.isEmpty(symbol) ||
                    (relativeChartFlag && items.id !== 19) ||
                    (selectedItems.length >= 3 &&
                      !_.includes(selectedItems, items.id) &&
                      items.id !== SUB_CHART[19].id) ||
                    (items.id === SUB_CHART[16].id && term.id !== TERM[9].id) ||
                    plotType.id === PLOTTYPE[3].id ||
                    (!relativeChartFlag && items.id === SUB_CHART[19].id),
                })}
              />
              <div
                onMouseOver={e => {
                  if (tooltipVisible !== items.id) setTooltipVisible(items.id)
                  _setPosition(e)
                }}
                className="help-icons"
              >
                <i className="material-icons">help_outline</i>
              </div>
              {tooltipVisible === items.id && createToolTip(items.id)}
              <i
                className="material-icons"
                onClick={() => _setVisibleList(items.id)}
              >
                {_.includes(visibleList, items.id)
                  ? "keyboard_arrow_up"
                  : "keyboard_arrow_down"}
              </i>
            </div>
            {_.includes(visibleList, items.id) && (
              <SubChartOptions
                canvasId={canvasId}
                subChartId={items.id}
                options={items.options}
              />
            )}
          </div>
        )
      })}
    </div>
  )
})

const CHECK_ITEMS = [
  {
    subChartId: 0,
    subChartOptionsId: 0,
  },
  {
    subChartId: 2,
    subChartOptionsId: 0,
  },
  {
    subChartId: 3,
    subChartOptionsId: 0,
  },
  {
    subChartId: 4,
    subChartOptionsId: 1,
  },
  {
    subChartId: 5,
    subChartOptionsId: 0,
  },
  {
    subChartId: 6,
    subChartOptionsId: 0,
  },
  {
    subChartId: 7,
    subChartOptionsId: 0,
  },
  {
    subChartId: 8,
    subChartOptionsId: 0,
  },
  {
    subChartId: 8,
    subChartOptionsId: 1,
  },
  {
    subChartId: 9,
    subChartOptionsId: 0,
  },
  {
    subChartId: 9,
    subChartOptionsId: 1,
  },
  {
    subChartId: 9,
    subChartOptionsId: 2,
  },
  {
    subChartId: 11,
    subChartOptionsId: 0,
  },
  {
    subChartId: 14,
    subChartOptionsId: 0,
  },
  {
    subChartId: 15,
    subChartOptionsId: 0,
  },
  {
    subChartId: 17,
    subChartOptionsId: 0,
  },
  {
    subChartId: 18,
    subChartOptionsId: 0,
  },
  {
    subChartId: 19,
    subChartOptionsId: 0,
  },
  {
    subChartId: 19,
    subChartOptionsId: 1,
  },
]

const SubChartOptions = React.memo((props: subChartOptionsProps) => {
  const { canvasId, subChartId } = props
  const dispatch = useDispatch()
  const providerSelector = (state: any) => state.chart[canvasId].providers
  const colorSettingSelector = (state: any) => state.chart.colorSetting
  const termSelector = (state: any) => state.chart[canvasId].term
  const relativeChartFlagSelector = (state: any) =>
    state.chart[canvasId].relativeChartFlag

  const providers = useSelector(providerSelector)
  const chartSettingSelector = (state: any) => state.chart.chartSetting
  const colorSetting = useSelector(colorSettingSelector)
  const chartSetting = useSelector(chartSettingSelector)
  const term = useSelector(termSelector)
  const relativeChartFlag = useSelector(relativeChartFlagSelector)

  const subChartSelector = (state: any) =>
    state.chart[canvasId].subChart[term.id]
  const subChartOptionsSelector = (state: any) =>
    state.chart[canvasId].subChartOptions[term.id]
  const subChart = useSelector(subChartSelector)
  const subChartOptions = useSelector(subChartOptionsSelector)

  const [_provider, _controller, _procs] = providers
  const [selectedOptions, setSelectedOPtions] = useState(
    (() => {
      let _data: Array<number | null> = []
      if (!_.isEmpty(subChartOptions[SUB_CHART[subChartId].key])) {
        _.forEach(subChartOptions[SUB_CHART[subChartId].key], items => {
          _data.push(items.id)
        })
      }
      return _data
    })()
  )

  const setOptions = (id: number) => {
    const _selectedOptions = _.clone(selectedOptions)
    if (_.includes(selectedOptions, id)) {
      _.pull(_selectedOptions, id)
    } else {
      _selectedOptions.push(id)
    }
    setSelectedOPtions(_selectedOptions)
    dispatch(
      changeSubChartOptions(
        canvasId,
        props.subChartId,
        _selectedOptions,
        term.id
      )
    )
  }

  const visibleCheckBox = (subChartId: number, subChartOptionsId: number) => {
    const target = { subChartId, subChartOptionsId }
    return !_.find(CHECK_ITEMS, target)
  }

  useEffect(() => {
    const _selectedOptions = _.map(
      subChartOptions[SUB_CHART[subChartId].key],
      items => {
        return items.id
      }
    )
    setSelectedOPtions(_selectedOptions)
  }, [subChartOptions[SUB_CHART[subChartId].key]])

  // ColorSettingに変更があった場合作り直しが必要。その際、親コンポーネントのuesEffect後にsetAddonChartが処理される必要があるため、setTimeoutで処理を遅らせている。
  useEffect(() => {
    if (!_.find(subChart, _.pick(SUB_CHART[subChartId], pickTarget))) return

    setTimeout(
      () =>
        (() => {
          _.forEach(subChart, items => {
            let keys: Array<string> = []
            _.forEach(subChartOptions[items.key], options => {
              keys.push(options.key)
            })
            if (relativeChartFlag) return
            setSubChart(
              chartSetting,
              items.key,
              _controller,
              term.key,
              keys,
              true
            )
          })
        })(),
      100
    )
  }, [selectedOptions, chartSetting, colorSetting])

  return (
    <div className="chart-setting-options">
      {_.map(props.options, items => {
        return (
          <div key={items.id} className="chart-setting-options-item">
            {visibleCheckBox(props.subChartId, items.id) ? (
              <label className="checkbox-control">
                <input
                  type="checkbox"
                  value={items.id}
                  checked={_.includes(selectedOptions, items.id)}
                  onChange={() => setOptions(items.id)}
                />
                <span>{items.displayTitle}</span>
              </label>
            ) : (
              <span>{items.displayTitle}</span>
            )}
            <SubChartPropety
              displayTitle={items.displayTitle}
              targetGroup={SUB_CHART[props.subChartId].key}
              target={items.key}
              canvasId={canvasId}
            />
          </div>
        )
      })}
    </div>
  )
})

export default SubChart
